var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API, GRAPHQL_AUTH_MODE, graphqlOperation } from '@aws-amplify/api';
/**
 * Log to the console.
 * @param logType Type of log: ERROR, DEBUG, WARN, INFO, or <YOUR CUSTOM TYPE>.
 * @param output The content of the output
 */
export function logger(logType, output) {
    return __awaiter(this, void 0, void 0, function* () {
        // console.log(logType, ' : ', output);
    });
}
export function callGraphQL(query, options) {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield API.graphql(graphqlOperation(query, options)));
    });
}
export function callGraphQLAPIKey(query, options) {
    return __awaiter(this, void 0, void 0, function* () {
        return API.graphql(Object.assign({ authMode: GRAPHQL_AUTH_MODE.API_KEY }, graphqlOperation(query, options)));
    });
}
export * from './types/OptionalListParams';
export * from './types/ListResults';
